import IndustrySettings from './industry-settings'
import ProviderCancellationFees from './provider-cancellation-fees'
import ProviderPaymentBonus from './provider-payment-bonus'
import ProviderAvailabilitySettings from './provider-availability-settings'
import ProviderProfileSettings from './provider-profile-settings'
import AsapAvailabilitySettings from './asap-availability'
import ExclusiveRideSettings from './exclusive-ride-settings'
import ProviderArrivalCompletedProximity from './provider-arrival-completed-proximity'
import TimeDelaySettings from './time-delay-settings'
import ReferralCodeSettings from './referral-code-settings'
import OfferSettings from './offer-settings'
import VersionSettings from './version-settings'
import StagingLotSettings from './staging-lot-settings'
import AutoDispatch from './auto-dispatch'
import AutoPackageRuns from './auto-package-runs'
import AutoDispatchRuns from './auto-dispatch-runs'
import KioskAppSettings from './kiosk-app-settings'
import AutoPackageSettings from './auto-package-settings'
import SharedTimeAvailability from './shared-time-availability'
import AirportSuggestedPickupTime from './airport-suggested-pickup-time'
import DriverBadRatingNotification from './driver-bad-rating-notification'
import DispatchNotificationSettings from './dispatch-notification-settings'
import DispatchSettings from './dispatch-settings'

import RsvpPoolSettings from './rsvp-pool-settings'
import RsvpOptinSettings from './rsvp-optin-settings'
import TransportationTimeoutSettings from './transportation-timeout-settings'
import HotelTimeoutSettings from './hotel-timeout-settings'
import OfferLimits from './offer-limits'
import URLSettings from './url-settings'
import GeofenceUniversalSettings from './geofence-universal-settings'
import WebsiteRSVPForm from './website-rsvp-form'
import ReservationSettings from './reservation-settings'
import CancellationFees from './cancellation-fees'
import ConsumerClients from './consumer-clients'
import MilitaryTime from './military-time'
import FraudDetection from './fraud-detection'
import PickupTimeOffsets from './pickuptime-offsets'
import CorporateProfile from './corporate-profile'
import MtechSettings from './mtech-settings'
import ProviderWorkLimit from './provider-work-limit'
import TightRoute from './tight-route'
import D2DSettings from './d2d-settings'
import LyftSettings from './lyft-settings'
import Rental from './rental'

let col1 = {
  // IndustrySettings,
  ProviderCancellationFees,
  ProviderPaymentBonus,
  ProviderAvailabilitySettings,
  ProviderProfileSettings,
  AsapAvailabilitySettings,
  ExclusiveRideSettings,
  ProviderArrivalCompletedProximity,
  TimeDelaySettings,
  ReferralCodeSettings,
  OfferSettings,
  VersionSettings,
  StagingLotSettings,
  AutoDispatch,
  AutoDispatchRuns,
  AutoPackageRuns,
  AutoPackageSettings,
  ProviderWorkLimit,
  TightRoute,
  KioskAppSettings,
  SharedTimeAvailability,
  AirportSuggestedPickupTime,
  DriverBadRatingNotification,
  DispatchNotificationSettings,
  DispatchSettings,
  MtechSettings,
  Rental,
  LyftSettings
}

let col2 = {
  RsvpPoolSettings,
  RsvpOptinSettings,
  TransportationTimeoutSettings,
  HotelTimeoutSettings,
  OfferLimits,
  URLSettings,
  GeofenceUniversalSettings,
  WebsiteRSVPForm,
  ReservationSettings,
  CancellationFees,
  ConsumerClients,
  MilitaryTime,
  FraudDetection,
  PickupTimeOffsets,
  CorporateProfile,
  D2DSettings
}

export default [ col1, col2 ]



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/index.js